import { ChangeDetectorRef, Component, NgZone, inject } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import {
  IonIcon,
  IonSpinner
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  alertCircleOutline,
  mailOutline,
  arrowBackOutline,
  checkmarkCircleOutline
} from 'ionicons/icons';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    RouterLink,
    IonIcon,
    IonSpinner,
    TranslatePipe
],
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  private readonly ngZone = inject(NgZone);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);

  email = '';
  isLoading = false;
  errorMessage = '';
  isSubmitted = false;

  constructor(private authService: AuthService) {
    addIcons({
      alertCircleOutline,
      mailOutline,
      arrowBackOutline,
      checkmarkCircleOutline
    });
  }

  onSubmit(): void {
    if (!this.isFormValid()) {
      this.errorMessage = 'INVALID_EMAIL';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';
    this.authService.forgotPassword({ email: this.email.trim() }).subscribe({
      next: (response) => {
        this.runInAngular(() => {
          this.isLoading = false;
          if (response.success) {
            this.isSubmitted = true;
          }
        });
      },
      error: (error) => {
        this.runInAngular(() => {
          this.isLoading = false;
          this.errorMessage = this.resolveErrorKey(error, 'FORGOT_PASSWORD_ERROR');
        });
      }
    });
  }

  isFormValid(): boolean {
    return this.authService.isEmailValid(this.email);
  }

  isEmailValid(): boolean {
    return this.email.length === 0 || this.authService.isEmailValid(this.email);
  }

  resetForm(): void {
    this.email = '';
    this.isSubmitted = false;
    this.errorMessage = '';
  }

  private runInAngular(callback: () => void): void {
    this.ngZone.run(() => {
      callback();
      this.changeDetectorRef.detectChanges();
    });
  }

  private resolveErrorKey(error: any, fallbackKey: string): string {
    const message = error?.error?.message || error?.message;
    if (typeof message === 'string' && /^[A-Z0-9_]+$/.test(message)) {
      return message;
    }
    return fallbackKey;
  }
}
